
// // import React, { useState, useEffect } from 'react';
// // import { Trash2, Plus, RefreshCw, AlertCircle, Megaphone, Sparkles, CheckCircle, ChevronLeft, ChevronRight, X } from 'lucide-react';
// // import axios from 'axios';
// // import { BASE_URL } from '../../../services/configUrls';

// // const Announcement = () => {
// //   const [announcements, setAnnouncements] = useState([]);
// //   const [newDescription, setNewDescription] = useState('');
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState('');
// //   const [success, setSuccess] = useState('');
// //   const [deletingId, setDeletingId] = useState(null);
  
// //   // Confirmation modals
// //   const [showAddConfirm, setShowAddConfirm] = useState(false);
// //   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
// //   const [itemToDelete, setItemToDelete] = useState(null);
  
// //   // Pagination state
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const itemsPerPage = 10;

// //   // Get auth token - try multiple sources
// //   const getAuthToken = () => {
// //     const token = localStorage.getItem('token') || 
// //                   localStorage.getItem('authToken') || 
// //                   localStorage.getItem('access_token') ||
// //                   localStorage.getItem('accessToken');
    
// //     if (token && !token.startsWith('Bearer ')) {
// //       return `Bearer ${token}`;
// //     }
// //     return token;
// //   };

// //   useEffect(() => {
// //     fetchAnnouncements();
// //   }, []);

// //   // Pagination calculations
// //   const totalPages = Math.ceil(announcements.length / itemsPerPage);
// //   const startIndex = (currentPage - 1) * itemsPerPage;
// //   const endIndex = startIndex + itemsPerPage;
// //   const currentAnnouncements = announcements.slice(startIndex, endIndex);

// //   const fetchAnnouncements = async () => {
// //     setLoading(true);
// //     setError('');
    
// //     const authToken = getAuthToken();
    
// //     if (!authToken) {
// //       setError('Authentication token not found. Please login again.');
// //       setLoading(false);
// //       return;
// //     }
    
// //     try {
// //       const config = {
// //         method: 'get',
// //         maxBodyLength: Infinity,
// //         url: `${BASE_URL}/documents/announcements`,
// //         headers: { 
// //           'Authorization': authToken
// //         }
// //       };

// //       const response = await axios.request(config);
      
// //       if (response.data && Array.isArray(response.data)) {
// //         setAnnouncements(response.data);
// //         setCurrentPage(1);
// //       } else {
// //         setAnnouncements([]);
// //       }
// //     } catch (err) {
// //       console.error('Error fetching announcements:', err);
// //       if (err.response?.status === 401) {
// //         setError('Session expired. Please login again.');
// //       } else {
// //         setError(err.response?.data?.detail || 'Failed to load announcements. Please try again.');
// //       }
// //       setAnnouncements([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleAddClick = () => {
// //     if (!newDescription.trim()) {
// //       setError('Please enter an announcement description');
// //       return;
// //     }
// //     setShowAddConfirm(true);
// //   };

// //   const confirmAddAnnouncement = async () => {
// //     const authToken = getAuthToken();
    
// //     if (!authToken) {
// //       setError('Authentication token not found. Please login again.');
// //       setShowAddConfirm(false);
// //       return;
// //     }

// //     setLoading(true);
// //     setError('');
// //     setSuccess('');
// //     setShowAddConfirm(false);
    
// //     try {
// //       let data = JSON.stringify({
// //         "description": newDescription
// //       });

// //       let config = {
// //         method: 'post',
// //         maxBodyLength: Infinity,
// //         url: `${BASE_URL}/documents/addAnnouncements`,
// //         headers: { 
// //           'Content-Type': 'application/json',
// //           'Authorization': authToken
// //         },
// //         data: data
// //       };

// //       const response = await axios.request(config);
      
// //       setSuccess('Announcement added successfully!');
// //       setNewDescription('');
// //       await fetchAnnouncements();
      
// //       setTimeout(() => setSuccess(''), 3000);
// //     } catch (err) {
// //       console.error('Error adding announcement:', err);
// //       if (err.response?.status === 401) {
// //         setError('Session expired. Please login again.');
// //       } else {
// //         setError(err.response?.data?.detail || 'Failed to add announcement. Please try again.');
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleDeleteClick = (announcement) => {
// //     setItemToDelete(announcement);
// //     setShowDeleteConfirm(true);
// //   };

// //   const confirmDeleteAnnouncement = async () => {
// //     if (!itemToDelete) return;

// //     const authToken = getAuthToken();
    
// //     if (!authToken) {
// //       setError('Authentication token not found. Please login again.');
// //       setShowDeleteConfirm(false);
// //       setItemToDelete(null);
// //       return;
// //     }

// //     setDeletingId(itemToDelete.announcementsid);
// //     setError('');
// //     setSuccess('');
// //     setShowDeleteConfirm(false);
    
// //     try {
// //       let data = JSON.stringify({
// //         "announcementsid": itemToDelete.announcementsid
// //       });

// //       let config = {
// //         method: 'post',
// //         maxBodyLength: Infinity,
// //         url: `${BASE_URL}/documents/deleteAnnouncements`,
// //         headers: { 
// //           'Content-Type': 'application/json',
// //           'Authorization': authToken
// //         },
// //         data: data
// //       };

// //       const response = await axios.request(config);
      
// //       setSuccess('Announcement deleted successfully!');
// //       await fetchAnnouncements();
      
// //       setTimeout(() => setSuccess(''), 3000);
// //     } catch (err) {
// //       console.error('Error deleting announcement:', err);
// //       if (err.response?.status === 401) {
// //         setError('Session expired. Please login again.');
// //       } else {
// //         setError(err.response?.data?.detail || 'Failed to delete announcement. Please try again.');
// //       }
// //     } finally {
// //       setDeletingId(null);
// //       setItemToDelete(null);
// //     }
// //   };

// //   const handlePageChange = (page) => {
// //     setCurrentPage(page);
// //   };

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-blue-900 via-navy-800 to-slate-900 p-4 sm:p-6">
// //       <style>{`
// //         @keyframes slideIn {
// //           from {
// //             opacity: 0;
// //             transform: translateY(10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
        
// //         @keyframes fadeIn {
// //           from { opacity: 0; }
// //           to { opacity: 1; }
// //         }
        
// //         @keyframes modalSlide {
// //           from {
// //             opacity: 0;
// //             transform: scale(0.95);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: scale(1);
// //           }
// //         }
        
// //         .animate-slide-in {
// //           animation: slideIn 0.3s ease-out forwards;
// //         }
        
// //         .animate-fade-in {
// //           animation: fadeIn 0.2s ease-out;
// //         }
        
// //         .animate-modal {
// //           animation: modalSlide 0.2s ease-out forwards;
// //         }
        
// //         .glass-card {
// //           background: rgba(255, 255, 255, 0.98);
// //           backdrop-filter: blur(10px);
// //           box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
// //         }
        
// //         .glass-header {
// //           background: linear-gradient(135deg, rgba(30, 58, 138, 0.9), rgba(15, 23, 42, 0.9));
// //           backdrop-filter: blur(15px);
// //           border: 1px solid rgba(59, 130, 246, 0.3);
// //         }
        
// //         .announcement-card {
// //           transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
// //         }
        
// //         .announcement-card:hover {
// //           transform: translateY(-2px);
// //           box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
// //         }
        
// //         .gradient-button {
// //           background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
// //           transition: all 0.2s ease;
// //         }
        
// //         .gradient-button:hover:not(:disabled) {
// //           transform: translateY(-1px);
// //           box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
// //         }
        
// //         .add-button {
// //           background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
// //         }
        
// //         .add-button:hover:not(:disabled) {
// //           transform: translateY(-1px);
// //           box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
// //         }
        
// //         .delete-button {
// //           transition: all 0.15s ease;
// //         }
        
// //         .delete-button:hover:not(:disabled) {
// //           transform: scale(1.05);
// //           background-color: #fef2f2;
// //         }

// //         .modal-overlay {
// //           background: rgba(0, 0, 0, 0.5);
// //           backdrop-filter: blur(4px);
// //         }
// //       `}</style>

// //       {/* Add Confirmation Modal */}
// //       {showAddConfirm && (
// //         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay animate-fade-in">
// //           <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-modal">
// //             <div className="flex items-start justify-between mb-4">
// //               <div className="flex items-center gap-3">
// //                 <div className="bg-blue-100 p-2 rounded-lg">
// //                   <AlertCircle className="w-6 h-6 text-blue-600" />
// //                 </div>
// //                 <h3 className="text-lg font-bold text-gray-900">Confirm Add Announcement</h3>
// //               </div>
// //               <button
// //                 onClick={() => setShowAddConfirm(false)}
// //                 className="text-gray-400 hover:text-gray-600 transition-colors"
// //               >
// //                 <X className="w-5 h-5" />
// //               </button>
// //             </div>
// //             <div className="mb-6">
// //               <p className="text-gray-600 mb-3">Are you sure you want to add this announcement?</p>
// //               <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
// //                 <p className="text-sm text-gray-800 font-medium">{newDescription}</p>
// //               </div>
// //             </div>
// //             <div className="flex gap-3 justify-end">
// //               <button
// //                 onClick={() => setShowAddConfirm(false)}
// //                 className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-sm"
// //               >
// //                 Cancel
// //               </button>
// //               <button
// //                 onClick={confirmAddAnnouncement}
// //                 className="add-button px-6 py-2 text-white rounded-lg font-semibold text-sm flex items-center gap-2"
// //               >
// //                 <Plus className="w-4 h-4" />
// //                 Add Announcement
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Delete Confirmation Modal */}
// //       {showDeleteConfirm && itemToDelete && (
// //         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay animate-fade-in">
// //           <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-modal">
// //             <div className="flex items-start justify-between mb-4">
// //               <div className="flex items-center gap-3">
// //                 <div className="bg-red-100 p-2 rounded-lg">
// //                   <AlertCircle className="w-6 h-6 text-red-600" />
// //                 </div>
// //                 <h3 className="text-lg font-bold text-gray-900">Confirm Delete</h3>
// //               </div>
// //               <button
// //                 onClick={() => {
// //                   setShowDeleteConfirm(false);
// //                   setItemToDelete(null);
// //                 }}
// //                 className="text-gray-400 hover:text-gray-600 transition-colors"
// //               >
// //                 <X className="w-5 h-5" />
// //               </button>
// //             </div>
// //             <div className="mb-6">
// //               <p className="text-gray-600 mb-3">Are you sure you want to delete this announcement? This action cannot be undone.</p>
// //               <div className="bg-red-50 p-3 rounded-lg border border-red-200">
// //                 <p className="text-sm text-gray-800 font-medium">{itemToDelete.description}</p>
// //               </div>
// //             </div>
// //             <div className="flex gap-3 justify-end">
// //               <button
// //                 onClick={() => {
// //                   setShowDeleteConfirm(false);
// //                   setItemToDelete(null);
// //                 }}
// //                 className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-sm"
// //               >
// //                 Cancel
// //               </button>
// //               <button
// //                 onClick={confirmDeleteAnnouncement}
// //                 className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-semibold text-sm flex items-center gap-2"
// //               >
// //                 <Trash2 className="w-4 h-4" />
// //                 Delete
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <div className="max-w-6xl mx-auto">
// //         {/* Header Card */}
// //         <div className="glass-header rounded-xl shadow-lg p-4 mb-4 animate-fade-in">
// //           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
// //             <div className="flex items-center gap-3">
// //               <div className="bg-gradient-to-br from-blue-500 to-blue-700 p-2 rounded-lg shadow-md">
// //                 <Megaphone className="w-4 h-4 text-white" />
// //               </div>
// //               <div>
// //                 <h1 className="text-lg sm:text-xl font-bold text-white mb-1 flex items-center gap-2">
// //                   Announcements
// //                   <Sparkles className="w-3 h-3 text-blue-300" />
// //                 </h1>
// //                 <p className="text-blue-200 text-xs">
// //                   Manage your login announcements
// //                 </p>
// //               </div>
// //             </div>
// //             <button
// //               onClick={fetchAnnouncements}
// //               disabled={loading}
// //               className="gradient-button text-white px-3 py-2 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-md text-xs"
// //             >
// //               <RefreshCw className={`w-3 h-3 ${loading ? 'animate-spin' : ''}`} />
// //               Refresh
// //             </button>
// //           </div>
// //         </div>

// //         {/* Main Content Card */}
// //         <div className="glass-card rounded-xl shadow-lg p-4 animate-slide-in">
          
// //           {/* Alert Messages */}
// //           {error && (
// //             <div className="mb-3 p-2 bg-gradient-to-r from-red-50 to-pink-50 border-l-4 border-red-500 rounded-lg flex items-start gap-2 animate-fade-in shadow-sm">
// //               <AlertCircle className="w-3 h-3 text-red-600 flex-shrink-0 mt-0.5" />
// //               <p className="text-red-800 font-medium text-xs">{error}</p>
// //             </div>
// //           )}

// //           {success && (
// //             <div className="mb-3 p-2 bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 rounded-lg flex items-start gap-2 animate-fade-in shadow-sm">
// //               <CheckCircle className="w-3 h-3 text-green-600 flex-shrink-0 mt-0.5" />
// //               <p className="text-green-800 font-medium text-xs">{success}</p>
// //             </div>
// //           )}

// //           {/* Add Announcement Section */}
// //           <div className="mb-4">
// //             <label className="block text-sm font-semibold text-gray-800 mb-2 flex items-center gap-1">
              
// //               Add New Announcement
// //             </label>
// //             <div className="flex flex-col sm:flex-row gap-2">
// //               <input
// //                 type="text"
// //                 value={newDescription}
// //                 onChange={(e) => setNewDescription(e.target.value)}
// //                 onKeyPress={(e) => e.key === 'Enter' && handleAddClick()}
// //                 placeholder="Enter announcement description..."
// //                 className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent outline-none text-gray-800 placeholder-gray-400 shadow-sm transition-all text-sm"
// //                 disabled={loading}
// //               />
// //               <button
// //                 onClick={handleAddClick}
// //                 disabled={loading || !newDescription.trim()}
// //                 className="add-button text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed shadow-md text-xs"
// //               >
// //                 <Plus className="w-3 h-3" />
// //                 Add
// //               </button>
// //             </div>
// //           </div>

// //           {/* Announcements List */}
// //           <div>
// //             <div className="flex items-center justify-between mb-2">
// //               <h2 className="text-base font-semibold text-gray-800 flex items-center gap-1">
// //                 <span className="bg-gradient-to-r from-blue-700 to-blue-900 text-transparent bg-clip-text">
// //                   Current Announcements
// //                 </span>
// //                 <span className="bg-gradient-to-r from-blue-600 to-blue-800 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
// //                   {announcements.length}
// //                 </span>
// //               </h2>
// //             </div>
            
// //             {loading && announcements.length === 0 ? (
// //               <div className="text-center py-8">
// //                 <RefreshCw className="w-6 h-6 animate-spin mx-auto mb-2 text-blue-600" />
// //                 <p className="text-gray-600 font-medium text-xs">Loading announcements...</p>
// //               </div>
// //             ) : announcements.length === 0 ? (
// //               <div className="text-center py-8 bg-gradient-to-br from-blue-50 to-slate-100 rounded-lg border border-dashed border-blue-200">
// //                 <Megaphone className="w-8 h-8 mx-auto mb-2 text-blue-300" />
// //                 <p className="text-gray-600 font-medium text-xs">No announcements yet</p>
// //                 <p className="text-gray-500 text-xs mt-1">Create your first announcement above!</p>
// //               </div>
// //             ) : (
// //               <>
// //                 <div className="space-y-2 mb-3">
// //                   {currentAnnouncements.map((announcement, index) => (
// //                     <div
// //                       key={announcement.announcementsid}
// //                       className="announcement-card flex items-start justify-between p-3 bg-gradient-to-r from-white to-blue-50 rounded-lg border border-blue-100 shadow-sm"
// //                       style={{ animationDelay: `${index * 0.05}s` }}
// //                     >
// //                       <div className="flex-1 flex items-start gap-2">
// //                         <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white w-6 h-6 rounded-full flex items-center justify-center font-semibold shadow-md flex-shrink-0 text-xs mt-0.5">
// //                           {startIndex + index + 1}
// //                         </div>
// //                         <div className="flex-1">
// //                           <p className="text-gray-800 font-medium text-sm leading-relaxed">
// //                             {announcement.description}
// //                           </p>
// //                         </div>
// //                       </div>
// //                       <button
// //                         onClick={() => handleDeleteClick(announcement)}
// //                         disabled={deletingId === announcement.announcementsid}
// //                         className="delete-button ml-2 p-1.5 text-red-600 hover:text-red-700 rounded disabled:opacity-50 disabled:cursor-not-allowed"
// //                         title="Delete announcement"
// //                       >
// //                         {deletingId === announcement.announcementsid ? (
// //                           <RefreshCw className="w-3 h-3 animate-spin" />
// //                         ) : (
// //                           <Trash2 className="w-3 h-3" />
// //                         )}
// //                       </button>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </>
// //             )}
// //           </div>
// //         </div>

// //         {/* Pagination */}
// //         {totalPages > 1 && (
// //           <div className="glass-card rounded-xl shadow-lg p-3 mt-3 animate-fade-in">
// //             <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
// //               <div className="text-xs text-gray-600">
// //                 Showing {startIndex + 1} to {Math.min(endIndex, announcements.length)} of {announcements.length} announcements
// //               </div>
// //               <div className="flex items-center gap-1">
// //                 <button
// //                   onClick={() => handlePageChange(currentPage - 1)}
// //                   disabled={currentPage === 1}
// //                   className="p-1.5 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
// //                 >
// //                   <ChevronLeft className="w-3 h-3" />
// //                 </button>
                
// //                 {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
// //                   <button
// //                     key={page}
// //                     onClick={() => handlePageChange(page)}
// //                     className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
// //                       currentPage === page
// //                         ? 'bg-blue-600 text-white'
// //                         : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
// //                     }`}
// //                   >
// //                     {page}
// //                   </button>
// //                 ))}
                
// //                 <button
// //                   onClick={() => handlePageChange(currentPage + 1)}
// //                   disabled={currentPage === totalPages}
// //                   className="p-1.5 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
// //                 >
// //                   <ChevronRight className="w-3 h-3" />
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default Announcement;

// import React, { useState, useEffect } from 'react';
// import { Trash2, Plus, RefreshCw, AlertCircle, Megaphone, Sparkles, CheckCircle, ChevronLeft, ChevronRight, X } from 'lucide-react';
// import axios from 'axios';
// import { BASE_URL } from '../../../services/configUrls';
// // import RichTextEditor from './RichTextEditor'; // Adjust the import path as needed
// import RichTextEditor from './RichTextEditor';
// const Announcement = () => {
//   const [announcements, setAnnouncements] = useState([]);
//   const [newDescription, setNewDescription] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [deletingId, setDeletingId] = useState(null);
  
//   // Confirmation modals
//   const [showAddConfirm, setShowAddConfirm] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [itemToDelete, setItemToDelete] = useState(null);
  
//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Get auth token - try multiple sources
//   const getAuthToken = () => {
//     const token = localStorage.getItem('token') || 
//                   localStorage.getItem('authToken') || 
//                   localStorage.getItem('access_token') ||
//                   localStorage.getItem('accessToken');
    
//     if (token && !token.startsWith('Bearer ')) {
//       return `Bearer ${token}`;
//     }
//     return token;
//   };

//   useEffect(() => {
//     fetchAnnouncements();
//   }, []);

//   // Pagination calculations
//   const totalPages = Math.ceil(announcements.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentAnnouncements = announcements.slice(startIndex, endIndex);

//   const fetchAnnouncements = async () => {
//     setLoading(true);
//     setError('');
    
//     const authToken = getAuthToken();
    
//     if (!authToken) {
//       setError('Authentication token not found. Please login again.');
//       setLoading(false);
//       return;
//     }
    
//     try {
//       const config = {
//         method: 'get',
//         maxBodyLength: Infinity,
//         url: `${BASE_URL}/documents/announcements`,
//         headers: { 
//           'Authorization': authToken
//         }
//       };

//       const response = await axios.request(config);
      
//       if (response.data && Array.isArray(response.data)) {
//         setAnnouncements(response.data);
//         setCurrentPage(1);
//       } else {
//         setAnnouncements([]);
//       }
//     } catch (err) {
//       console.error('Error fetching announcements:', err);
//       if (err.response?.status === 401) {
//         setError('Session expired. Please login again.');
//       } else {
//         setError(err.response?.data?.detail || 'Failed to load announcements. Please try again.');
//       }
//       setAnnouncements([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddClick = () => {
//     if (!newDescription.trim() || newDescription === '<p></p>') {
//       setError('Please enter an announcement description');
//       return;
//     }
//     setShowAddConfirm(true);
//   };

//   const confirmAddAnnouncement = async () => {
//     const authToken = getAuthToken();
    
//     if (!authToken) {
//       setError('Authentication token not found. Please login again.');
//       setShowAddConfirm(false);
//       return;
//     }

//     setLoading(true);
//     setError('');
//     setSuccess('');
//     setShowAddConfirm(false);
    
//     try {
//       let data = JSON.stringify({
//         "description": newDescription
//       });

//       let config = {
//         method: 'post',
//         maxBodyLength: Infinity,
//         url: `${BASE_URL}/documents/addAnnouncements`,
//         headers: { 
//           'Content-Type': 'application/json',
//           'Authorization': authToken
//         },
//         data: data
//       };

//       const response = await axios.request(config);
      
//       setSuccess('Announcement added successfully!');
//       setNewDescription('');
//       await fetchAnnouncements();
      
//       setTimeout(() => setSuccess(''), 3000);
//     } catch (err) {
//       console.error('Error adding announcement:', err);
//       if (err.response?.status === 401) {
//         setError('Session expired. Please login again.');
//       } else {
//         setError(err.response?.data?.detail || 'Failed to add announcement. Please try again.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteClick = (announcement) => {
//     setItemToDelete(announcement);
//     setShowDeleteConfirm(true);
//   };

//   const confirmDeleteAnnouncement = async () => {
//     if (!itemToDelete) return;

//     const authToken = getAuthToken();
    
//     if (!authToken) {
//       setError('Authentication token not found. Please login again.');
//       setShowDeleteConfirm(false);
//       setItemToDelete(null);
//       return;
//     }

//     setDeletingId(itemToDelete.announcementsid);
//     setError('');
//     setSuccess('');
//     setShowDeleteConfirm(false);
    
//     try {
//       let data = JSON.stringify({
//         "announcementsid": itemToDelete.announcementsid
//       });

//       let config = {
//         method: 'post',
//         maxBodyLength: Infinity,
//         url: `${BASE_URL}/documents/deleteAnnouncements`,
//         headers: { 
//           'Content-Type': 'application/json',
//           'Authorization': authToken
//         },
//         data: data
//       };

//       const response = await axios.request(config);
      
//       setSuccess('Announcement deleted successfully!');
//       await fetchAnnouncements();
      
//       setTimeout(() => setSuccess(''), 3000);
//     } catch (err) {
//       console.error('Error deleting announcement:', err);
//       if (err.response?.status === 401) {
//         setError('Session expired. Please login again.');
//       } else {
//         setError(err.response?.data?.detail || 'Failed to delete announcement. Please try again.');
//       }
//     } finally {
//       setDeletingId(null);
//       setItemToDelete(null);
//     }
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   // Function to strip HTML tags for display in confirmation modals
//   const stripHtml = (html) => {
//     const tmp = document.createElement('DIV');
//     tmp.innerHTML = html;
//     return tmp.textContent || tmp.innerText || '';
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-900 via-navy-800 to-slate-900 p-4 sm:p-6">
//       {/* ... (keep all your existing styles) ... */}

//       {/* Add Confirmation Modal */}
//       {showAddConfirm && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay animate-fade-in">
//           <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-modal">
//             <div className="flex items-start justify-between mb-4">
//               <div className="flex items-center gap-3">
//                 <div className="bg-blue-100 p-2 rounded-lg">
//                   <AlertCircle className="w-6 h-6 text-blue-600" />
//                 </div>
//                 <h3 className="text-lg font-bold text-gray-900">Confirm Add Announcement</h3>
//               </div>
//               <button
//                 onClick={() => setShowAddConfirm(false)}
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>
//             <div className="mb-6">
//               <p className="text-gray-600 mb-3">Are you sure you want to add this announcement?</p>
//               <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 max-h-32 overflow-y-auto">
//                 <div 
//                   className="text-sm text-gray-800 prose prose-sm"
//                   dangerouslySetInnerHTML={{ __html: newDescription }}
//                 />
//               </div>
//             </div>
//             <div className="flex gap-3 justify-end">
//               <button
//                 onClick={() => setShowAddConfirm(false)}
//                 className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-sm"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmAddAnnouncement}
//                 className="add-button px-6 py-2 text-white rounded-lg font-semibold text-sm flex items-center gap-2"
//               >
//                 <Plus className="w-4 h-4" />
//                 Add Announcement
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && itemToDelete && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay animate-fade-in">
//           <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-modal">
//             <div className="flex items-start justify-between mb-4">
//               <div className="flex items-center gap-3">
//                 <div className="bg-red-100 p-2 rounded-lg">
//                   <AlertCircle className="w-6 h-6 text-red-600" />
//                 </div>
//                 <h3 className="text-lg font-bold text-gray-900">Confirm Delete</h3>
//               </div>
//               <button
//                 onClick={() => {
//                   setShowDeleteConfirm(false);
//                   setItemToDelete(null);
//                 }}
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>
//             <div className="mb-6">
//               <p className="text-gray-600 mb-3">Are you sure you want to delete this announcement? This action cannot be undone.</p>
//               <div className="bg-red-50 p-3 rounded-lg border border-red-200 max-h-32 overflow-y-auto">
//                 <div 
//                   className="text-sm text-gray-800 prose prose-sm"
//                   dangerouslySetInnerHTML={{ __html: itemToDelete.description }}
//                 />
//               </div>
//             </div>
//             <div className="flex gap-3 justify-end">
//               <button
//                 onClick={() => {
//                   setShowDeleteConfirm(false);
//                   setItemToDelete(null);
//                 }}
//                 className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-sm"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmDeleteAnnouncement}
//                 className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-semibold text-sm flex items-center gap-2"
//               >
//                 <Trash2 className="w-4 h-4" />
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="max-w-6xl mx-auto">
//         {/* Header Card - keep as is */}
//         <div className="glass-header rounded-xl shadow-lg p-4 mb-4 animate-fade-in">
//           {/* ... (keep existing header content) ... */}

//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
//             <div className="flex items-center gap-3">
//               <div className="bg-gradient-to-br from-blue-500 to-blue-700 p-2 rounded-lg shadow-md">
//                 <Megaphone className="w-4 h-4 text-white" />
//               </div>
//               <div>
//                 <h1 className="text-lg sm:text-xl font-bold text-white mb-1 flex items-center gap-2">
//                   Announcements
//                   <Sparkles className="w-3 h-3 text-blue-300" />
//                 </h1>
//                 <p className="text-blue-200 text-xs">
//                   Manage your login announcements
//                 </p>
//               </div>
//             </div>
//             <button
//               onClick={fetchAnnouncements}
//               disabled={loading}
//               className="gradient-button text-white px-3 py-2 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-md text-xs"
//             >
//               <RefreshCw className={`w-3 h-3 ${loading ? 'animate-spin' : ''}`} />
//               Refresh
//             </button>
//           </div>
//         </div>

//         {/* Main Content Card */}
//         <div className="glass-card rounded-xl shadow-lg p-4 animate-slide-in">
          
//           {/* Alert Messages - keep as is */}
//           {error && (
//             <div className="mb-3 p-2 bg-gradient-to-r from-red-50 to-pink-50 border-l-4 border-red-500 rounded-lg flex items-start gap-2 animate-fade-in shadow-sm">
//               <AlertCircle className="w-3 h-3 text-red-600 flex-shrink-0 mt-0.5" />
//               <p className="text-red-800 font-medium text-xs">{error}</p>
//             </div>
//           )}

//           {success && (
//             <div className="mb-3 p-2 bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 rounded-lg flex items-start gap-2 animate-fade-in shadow-sm">
//               <CheckCircle className="w-3 h-3 text-green-600 flex-shrink-0 mt-0.5" />
//               <p className="text-green-800 font-medium text-xs">{success}</p>
//             </div>
//           )}

//           {/* Add Announcement Section - UPDATED */}
//           <div className="mb-4">
//             <label className="block text-sm font-semibold text-gray-800 mb-2">
//               Add New Announcement
//             </label>
//             <div className="space-y-2">
//               <RichTextEditor
//                 value={newDescription}
//                 onChange={setNewDescription}
//                 placeholder="Start typing your announcement..."
//               />
//               <div className="flex justify-end">
//                 <button
//                   onClick={handleAddClick}
//                   disabled={loading || !newDescription.trim() || newDescription === '<p></p>'}
//                   className="add-button text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed shadow-md text-xs"
//                 >
//                   <Plus className="w-3 h-3" />
//                   Add Announcement
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Announcements List - UPDATED to render HTML */}
//           <div>
//             <div className="flex items-center justify-between mb-2">
//               <h2 className="text-base font-semibold text-gray-800 flex items-center gap-1">
//                 <span className="bg-gradient-to-r from-blue-700 to-blue-900 text-transparent bg-clip-text">
//                   Current Announcements
//                 </span>
//                 <span className="bg-gradient-to-r from-blue-600 to-blue-800 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
//                   {announcements.length}
//                 </span>
//               </h2>
//             </div>
            
//             {loading && announcements.length === 0 ? (
//               <div className="text-center py-8">
//                 <RefreshCw className="w-6 h-6 animate-spin mx-auto mb-2 text-blue-600" />
//                 <p className="text-gray-600 font-medium text-xs">Loading announcements...</p>
//               </div>
//             ) : announcements.length === 0 ? (
//               <div className="text-center py-8 bg-gradient-to-br from-blue-50 to-slate-100 rounded-lg border border-dashed border-blue-200">
//                 <Megaphone className="w-8 h-8 mx-auto mb-2 text-blue-300" />
//                 <p className="text-gray-600 font-medium text-xs">No announcements yet</p>
//                 <p className="text-gray-500 text-xs mt-1">Create your first announcement above!</p>
//               </div>
//             ) : (
//               <>
//                 <div className="space-y-2 mb-3">
//                   {currentAnnouncements.map((announcement, index) => (
//                     <div
//                       key={announcement.announcementsid}
//                       className="announcement-card flex items-start justify-between p-3 bg-gradient-to-r from-white to-blue-50 rounded-lg border border-blue-100 shadow-sm"
//                       style={{ animationDelay: `${index * 0.05}s` }}
//                     >
//                       <div className="flex-1 flex items-start gap-2">
//                         <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white w-6 h-6 rounded-full flex items-center justify-center font-semibold shadow-md flex-shrink-0 text-xs mt-0.5">
//                           {startIndex + index + 1}
//                         </div>
//                         <div className="flex-1">
//                           <div 
//                             className="text-gray-800 text-sm leading-relaxed prose prose-sm max-w-none"
//                             dangerouslySetInnerHTML={{ __html: announcement.description }}
//                           />
//                         </div>
//                       </div>
//                       <button
//                         onClick={() => handleDeleteClick(announcement)}
//                         disabled={deletingId === announcement.announcementsid}
//                         className="delete-button ml-2 p-1.5 text-red-600 hover:text-red-700 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                         title="Delete announcement"
//                       >
//                         {deletingId === announcement.announcementsid ? (
//                           <RefreshCw className="w-3 h-3 animate-spin" />
//                         ) : (
//                           <Trash2 className="w-3 h-3" />
//                         )}
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>
//         </div>

//         {/* Pagination - keep as is */}
//         {totalPages > 1 && (
//           <div className="glass-card rounded-xl shadow-lg p-3 mt-3 animate-fade-in">
//             {/* ... (keep existing pagination) ... */}
//               <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
//               <div className="text-xs text-gray-600">
//                 Showing {startIndex + 1} to {Math.min(endIndex, announcements.length)} of {announcements.length} announcements
//               </div>
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={() => handlePageChange(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   className="p-1.5 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                 >
//                   <ChevronLeft className="w-3 h-3" />
//                 </button>
                
//                 {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
//                   <button
//                     key={page}
//                     onClick={() => handlePageChange(page)}
//                     className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
//                       currentPage === page
//                         ? 'bg-blue-600 text-white'
//                         : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
//                     }`}
//                   >
//                     {page}
//                   </button>
//                 ))}
                
//                 <button
//                   onClick={() => handlePageChange(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                   className="p-1.5 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                 >
//                   <ChevronRight className="w-3 h-3" />
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Announcement;
import React, { useState, useEffect } from 'react';
import { Trash2, Plus, RefreshCw, AlertCircle, Megaphone, Sparkles, CheckCircle, ChevronLeft, ChevronRight, X } from 'lucide-react';
import axios from 'axios';
import { BASE_URL } from '../../../services/configUrls';
import RichTextEditor from './RichTextEditor';

const Announcement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [newDescription, setNewDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [deletingId, setDeletingId] = useState(null);
  
  // Confirmation modals
  const [showAddConfirm, setShowAddConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Get auth token - try multiple sources
  const getAuthToken = () => {
    const token = localStorage.getItem('token') || 
                  localStorage.getItem('authToken') || 
                  localStorage.getItem('access_token') ||
                  localStorage.getItem('accessToken');
    
    if (token && !token.startsWith('Bearer ')) {
      return `Bearer ${token}`;
    }
    return token;
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // Pagination calculations
  const totalPages = Math.ceil(announcements.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAnnouncements = announcements.slice(startIndex, endIndex);

  const fetchAnnouncements = async () => {
    setLoading(true);
    setError('');
    
    const authToken = getAuthToken();
    
    if (!authToken) {
      setError('Authentication token not found. Please login again.');
      setLoading(false);
      return;
    }
    
    try {
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${BASE_URL}/documents/announcements`,
        headers: { 
          'Authorization': authToken
        }
      };

      const response = await axios.request(config);
      
      if (response.data && Array.isArray(response.data)) {
        setAnnouncements(response.data);
        setCurrentPage(1);
      } else {
        setAnnouncements([]);
      }
    } catch (err) {
      console.error('Error fetching announcements:', err);
      if (err.response?.status === 401) {
        setError('Session expired. Please login again.');
      } else {
        setError(err.response?.data?.detail || 'Failed to load announcements. Please try again.');
      }
      setAnnouncements([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddClick = () => {
    if (!newDescription.trim() || newDescription === '<p></p>') {
      setError('Please enter an announcement description');
      return;
    }
    setShowAddConfirm(true);
  };

  const confirmAddAnnouncement = async () => {
    const authToken = getAuthToken();
    
    if (!authToken) {
      setError('Authentication token not found. Please login again.');
      setShowAddConfirm(false);
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');
    setShowAddConfirm(false);
    
    try {
      let data = JSON.stringify({
        "description": newDescription
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${BASE_URL}/documents/addAnnouncements`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        data: data
      };

      const response = await axios.request(config);
      
      setSuccess('Announcement added successfully!');
      setNewDescription(''); // Clear the input field
      await fetchAnnouncements();
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error adding announcement:', err);
      if (err.response?.status === 401) {
        setError('Session expired. Please login again.');
      } else {
        setError(err.response?.data?.detail || 'Failed to add announcement. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (announcement) => {
    setItemToDelete(announcement);
    setShowDeleteConfirm(true);
  };

  const confirmDeleteAnnouncement = async () => {
    if (!itemToDelete) return;

    const authToken = getAuthToken();
    
    if (!authToken) {
      setError('Authentication token not found. Please login again.');
      setShowDeleteConfirm(false);
      setItemToDelete(null);
      return;
    }

    setDeletingId(itemToDelete.announcementsid);
    setError('');
    setSuccess('');
    setShowDeleteConfirm(false);
    
    try {
      let data = JSON.stringify({
        "announcementsid": itemToDelete.announcementsid
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${BASE_URL}/documents/deleteAnnouncements`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        data: data
      };

      const response = await axios.request(config);
      
      setSuccess('Announcement deleted successfully!');
      await fetchAnnouncements();
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error deleting announcement:', err);
      if (err.response?.status === 401) {
        setError('Session expired. Please login again.');
      } else {
        setError(err.response?.data?.detail || 'Failed to delete announcement. Please try again.');
      }
    } finally {
      setDeletingId(null);
      setItemToDelete(null);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-navy-800 to-slate-900 p-4 sm:p-6">
      {/* Add Confirmation Modal */}
      {showAddConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay animate-fade-in">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-modal">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <AlertCircle className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">Confirm Add Announcement</h3>
              </div>
              <button
                onClick={() => setShowAddConfirm(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">Are you sure you want to add this announcement?</p>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 max-h-32 overflow-y-auto">
                <div 
                  className="text-sm text-gray-800 prose prose-sm"
                  dangerouslySetInnerHTML={{ __html: newDescription }}
                />
              </div>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => setShowAddConfirm(false)}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-sm"
              >
                Cancel
              </button>
              <button
                onClick={confirmAddAnnouncement}
                className="add-button px-6 py-2 text-white rounded-lg font-semibold text-sm flex items-center gap-2"
              >
                <Plus className="w-4 h-4" />
                Add Announcement
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && itemToDelete && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay animate-fade-in">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-modal">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="bg-red-100 p-2 rounded-lg">
                  <AlertCircle className="w-6 h-6 text-red-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">Confirm Delete</h3>
              </div>
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setItemToDelete(null);
                }}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">Are you sure you want to delete this announcement? This action cannot be undone.</p>
              <div className="bg-red-50 p-3 rounded-lg border border-red-200 max-h-32 overflow-y-auto">
                <div 
                  className="text-sm text-gray-800 prose prose-sm"
                  dangerouslySetInnerHTML={{ __html: itemToDelete.description }}
                />
              </div>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setItemToDelete(null);
                }}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-sm"
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteAnnouncement}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-semibold text-sm flex items-center gap-2"
              >
                <Trash2 className="w-4 h-4" />
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto">
        {/* Header Card */}
        <div className="glass-header rounded-xl shadow-lg p-4 mb-4 animate-fade-in">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="bg-gradient-to-br from-blue-500 to-blue-700 p-2 rounded-lg shadow-md">
                <Megaphone className="w-4 h-4 text-white" />
              </div>
              <div>
                <h1 className="text-lg sm:text-xl font-bold text-white mb-1 flex items-center gap-2">
                  Announcements
                  <Sparkles className="w-3 h-3 text-blue-300" />
                </h1>
                <p className="text-blue-200 text-xs">
                  Manage your login announcements
                </p>
              </div>
            </div>
            <button
              onClick={fetchAnnouncements}
              disabled={loading}
              className="gradient-button text-white px-3 py-2 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-md text-xs"
            >
              <RefreshCw className={`w-3 h-3 ${loading ? 'animate-spin' : ''}`} />
              Refresh
            </button>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="glass-card rounded-xl shadow-lg p-4 animate-slide-in">
          
          {/* Alert Messages */}
          {error && (
            <div className="mb-3 p-2 bg-gradient-to-r from-red-50 to-pink-50 border-l-4 border-red-500 rounded-lg flex items-start gap-2 animate-fade-in shadow-sm">
              <AlertCircle className="w-3 h-3 text-red-600 flex-shrink-0 mt-0.5" />
              <p className="text-red-800 font-medium text-xs">{error}</p>
            </div>
          )}

          {success && (
            <div className="mb-3 p-2 bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 rounded-lg flex items-start gap-2 animate-fade-in shadow-sm">
              <CheckCircle className="w-3 h-3 text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-green-800 font-medium text-xs">{success}</p>
            </div>
          )}

          {/* Add Announcement Section - UPDATED */}
          <div className="mb-4">
            <label className="block text-sm font-semibold text-gray-800 mb-2">
              Add New Announcement
            </label>
            <div className="space-y-2">
              <div className="rich-text-editor-container" >
                <RichTextEditor
                  value={newDescription}
                  onChange={setNewDescription}
                  placeholder="Start typing your announcement..."
                />
              </div>
              <div className="flex justify-end">
                <button
                  onClick={handleAddClick}
                  disabled={loading || !newDescription.trim() || newDescription === '<p></p>'}
                  className="add-button text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed shadow-md text-xs"
                >
                  <Plus className="w-3 h-3" />
                  Add Announcement
                </button>
              </div>
            </div>
          </div>

          {/* Announcements List */}
          <div>
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-base font-semibold text-gray-800 flex items-center gap-1">
                <span className="bg-gradient-to-r from-blue-700 to-blue-900 text-transparent bg-clip-text">
                  Current Announcements
                </span>
                <span className="bg-gradient-to-r from-blue-600 to-blue-800 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                  {announcements.length}
                </span>
              </h2>
            </div>
            
            {loading && announcements.length === 0 ? (
              <div className="text-center py-8">
                <RefreshCw className="w-6 h-6 animate-spin mx-auto mb-2 text-blue-600" />
                <p className="text-gray-600 font-medium text-xs">Loading announcements...</p>
              </div>
            ) : announcements.length === 0 ? (
              <div className="text-center py-8 bg-gradient-to-br from-blue-50 to-slate-100 rounded-lg border border-dashed border-blue-200">
                <Megaphone className="w-8 h-8 mx-auto mb-2 text-blue-300" />
                <p className="text-gray-600 font-medium text-xs">No announcements yet</p>
                <p className="text-gray-500 text-xs mt-1">Create your first announcement above!</p>
              </div>
            ) : (
              <>
                <div className="space-y-2 mb-3">
                  {currentAnnouncements.map((announcement, index) => (
                    <div
                      key={announcement.announcementsid}
                      className="announcement-card flex items-start justify-between p-3 bg-gradient-to-r from-white to-blue-50 rounded-lg border border-blue-100 shadow-sm"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="flex-1 flex items-start gap-2">
                        <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white w-6 h-6 rounded-full flex items-center justify-center font-semibold shadow-md flex-shrink-0 text-xs mt-0.5">
                          {startIndex + index + 1}
                        </div>
                        <div className="flex-1">
                          <div 
                            className="text-gray-800 text-sm leading-relaxed prose prose-sm max-w-none"
                            dangerouslySetInnerHTML={{ __html: announcement.description }}
                          />
                        </div>
                      </div>
                      <button
                        onClick={() => handleDeleteClick(announcement)}
                        disabled={deletingId === announcement.announcementsid}
                        className="delete-button ml-2 p-1.5 text-red-600 hover:text-red-700 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Delete announcement"
                      >
                        {deletingId === announcement.announcementsid ? (
                          <RefreshCw className="w-3 h-3 animate-spin" />
                        ) : (
                          <Trash2 className="w-3 h-3" />
                        )}
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="glass-card rounded-xl shadow-lg p-3 mt-3 animate-fade-in">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
              <div className="text-xs text-gray-600">
                Showing {startIndex + 1} to {Math.min(endIndex, announcements.length)} of {announcements.length} announcements
              </div>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="p-1.5 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <ChevronLeft className="w-3 h-3" />
                </button>
                
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
                      currentPage === page
                        ? 'bg-blue-600 text-white'
                        : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    {page}
                  </button>
                ))}
                
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="p-1.5 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <ChevronRight className="w-3 h-3" />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .add-button {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        }
        .add-button:hover:not(:disabled) {
          background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
        }
        .gradient-button {
          background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
        }
        .gradient-button:hover:not(:disabled) {
          background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
        }
        .delete-button:hover:not(:disabled) {
          background-color: #fef2f2;
        }
        .glass-header {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.9) 0%, rgba(30, 64, 175, 0.9) 100%);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        .glass-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        .modal-overlay {
          background: rgba(0, 0, 0, 0.5);
        }
        .animate-fade-in {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slide-in {
          animation: slideIn 0.4s ease-out;
        }
        .animate-modal {
          animation: modalSlideIn 0.2s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideIn {
          from { 
            opacity: 0;
            transform: translateY(20px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes modalSlideIn {
          from { 
            opacity: 0;
            transform: scale(0.9) translateY(-10px);
          }
          to { 
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Announcement;